import React, { useRef } from 'react';
import { motion } from 'framer-motion';
import { useInView } from 'framer-motion';
export function Philosophy() {
  const ref = useRef(null);
  const isInView = useInView(ref, {
    once: true,
    margin: '-100px'
  });
  return <section className="w-full bg-bp-bg py-20 px-6 md:px-20" data-id="element-111">
      <motion.div ref={ref} className="max-w-prose2 mx-auto text-center" initial={{
      opacity: 0,
      y: 20
    }} animate={isInView ? {
      opacity: 1,
      y: 0
    } : {
      opacity: 0,
      y: 20
    }} transition={{
      duration: 0.6
    }} data-id="element-112">
        <h2 className="font-display text-bp-accent text-sm md:text-base tracking-[0.3em] uppercase mb-8" data-id="element-113">
          NUESTRA FILOSOFÍA
        </h2>

        <p className="font-body font-light text-bp-text text-xl md:text-2xl leading-loose" data-id="element-114">
          No hacemos comida rápida. Hacemos kebabs y papas horneadas con
          ingredientes reales, preparados al momento.
        </p>
      </motion.div>
    </section>;
}